import { render, staticRenderFns } from "./ProjectMembersTab.vue?vue&type=template&id=cd3d7d2a"
import script from "./ProjectMembersTab.vue?vue&type=script&lang=ts"
export * from "./ProjectMembersTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports